<template>
	<table class="subscription-products">
		<tbody>
			<th>Abonnemang</th>
			<tr>
				<td class="small">Telefon</td>
				<td class="subscription-cost small">{{ subscriptionProducts.monthlyCost }} kr/mån</td>
			</tr>
			<tr v-for="(product, index) in subscriptionProducts.additionalProducts" :key="product.productId">
				<template v-if="product.display">
					<td class="small">{{ product.name }}</td>
					<td class="subscription-cost small">{{ product.monthlyCost }} kr/mån</td>
				</template>
			</tr>
			<tr>
				<td class="subscription-total-cost small">Total månadskostnad</td>
				<td class="subscription-cost subscription-total-cost small">{{ subscriptionProducts.monthlyCost + totalMonthlyCost }} kr/mån</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
export default {
	props: {
		subscriptionProducts: {
			type: Object,
			required: true,
		},
	},
	computed: {
		totalMonthlyCost () {
			return Object.values(this.subscriptionProducts.additionalProducts).reduce((t, {monthlyCost}) => t + monthlyCost, 0);
		},
	},
};
</script>